import { Box, Grid, Typography, styled, useTheme } from "@mui/material";

import CardSkeleton from "components/Skeletons/Card.Skeleton";
import { DefaultUrlWeb } from "config/Configuration";
import FancyCard from "components/FancyCard";
import NumberFormats from "components/NumberFormats";
import PortfolioChart from "./PortfolioChart";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import useDispatch from "hooks/useDispatch";
import { getPortfolioChart } from "store/slices/portfolio/portfolioSlice";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

function PortfolioChartBox({ title }) {
  const theme = useTheme();
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();

  const portfolioChartForm = useSelector((state) => state.portfolio?.portfolioChartForm?.data);
  const portfolioChart = useSelector(
    (state) => state.portfolio.portfolioChart?.data
  );

  const defaultPortfolioChartForm = useMemo(() => portfolioChartForm?.lisPortfolioChartFormDetail?.find((l) => l?.id === portfolioChartForm?.portfolioChartFormDetailId), [portfolioChartForm])

  const portfolioTab = +searchParams.get("portfolioTab") || defaultPortfolioChartForm?.portfolioId || 1;
  const basketTab = +searchParams.get("basketTab") || "";

  useEffect(() => {
    dispatch(getPortfolioChart({ portfolioId: portfolioTab, basketId: basketTab }))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basketTab])


  return (
    <>
      {portfolioChart ? (
        <FancyCard color={theme.palette.background.blue}>
          <Grid container>
            <BoxDate>
              <Typography component="small">
                {portfolioChart?.date} <br /> {portfolioChart?.time}
              </Typography>
            </BoxDate>

            <Grid item xs={12} md={6}>
              <Typography sx={{ mb: 3 }} variant="h4" color="common.white">
                {title}
              </Typography>

              <Typography
                sx={{ mb: 2 }}
                variant="h5"
                fontWeight={400}
                color="common.white"
              >
                Total Asset Value:
              </Typography>

              <BoxCoin>
                <img src={DefaultUrlWeb + `/images/coin/usdt.png`} alt="USDT" />
                <Typography variant="h3" color="common.white" fontWeight={400}>
                  <NumberFormats value={portfolioChart?.creditCostMarketUSDT} />
                  <Typography component="small" fontWeight={300}>
                    USDT
                  </Typography>
                </Typography>
              </BoxCoin>
            </Grid>

            <Grid item xs={12} md={6}>
              <PortfolioChart
                color={theme.palette.common.white}
                portfolioChart={portfolioChart?.creditDetail}
              />
            </Grid>
          </Grid>
        </FancyCard>
      ) : (
        <CardSkeleton heightSize={188} />
      )}
    </>
  );
}

const BoxCoin = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(1.3),
  img: {
    width: "25px",
    marginRight: theme.spacing(1),
  },
  small: {
    fontSize: "12px",
    marginLeft: theme.spacing(0.7),
  },
}));

const BoxDate = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "20px",
  right: "20px",
  color: `${theme.palette.text.main}90`,
  fontWeight: "300",
  fontSize: "12px",
  lineHeight: "18px",
  textAlign: "right",
  small: {
    color: `${theme.palette.text.main}90`,
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "18px",
    textAlign: "end",
  },
}));

export default PortfolioChartBox;
